import {
  clazzAllowUserTypes,
  ClazzAssessmentAllowSubjects,
  RESEARCH_STAFF
} from '@/common/allow-list'
import { Component, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
@Component({
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      // 通过 `vm` 访问组件实例，对学科进行判断
      vm.ROUTER_FROM = from

      if (vm._user && clazzAllowUserTypes.indexOf(vm._user.user_type) > -1) {
        const arr = vm._user.subjects.filter((n) => {
          return ClazzAssessmentAllowSubjects.find((item) => item.value == n[0])
        })
        if (arr && arr.length) {
          console.log('pass')
        } else {
          vm.$router.replace({ path: '/clazz/nopermission' })
        }
      } else {
        vm.$router.replace({ path: '/clazz/nopermission' })
      }
    })
  }
})
export default class RouterMxin extends Vue {
  private get _user() {
    return this.$store.state.user_info
  }

  public ROUTER_FROM: any = {}
}
